import {Image, Table, Tag} from "antd";
import {useNavigate} from "react-router-dom";
import './index.scss'

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {minutesToHours} from "../../helper/minutesToHours";

// Dayjs sozlash
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Tashkent");

const AttendanceTable = ({data}) => {
    const navigate = useNavigate();


    const Edit = (id) => {
        navigate(`/faceid/add?editId=${id}`)
    };


    const columns = [

        {
            title: 'Изображение',
            dataIndex: 'image',
            key: 'image',
            render: (image) => (
                <Image
                    width={50}
                    src={`${process.env.REACT_APP_API_URL}${image?.url}`}
                    preview={false}
                />
            ),
        },

        {
            title: 'Сотрудник Ф.И.О',
            dataIndex: ['employeeId', 'user_name'],
            key: 'user_name',
            render: (text) => <p>{text}</p>
        },

        {
            title: 'Должность',
            dataIndex: ['employeeId', 'position'],
            key: 'position',
            render: (text) => <p>{text}</p>
        },

        {
            title: 'Офис',
            dataIndex: ['officeId', 'name'],
            key: 'office',
            render: (text) => <p>{text}</p>,
        },

        {
            title: 'Дата / Время',
            dataIndex: 'dateTime',
            key: 'dateTime',
            render: (text) => (

                    <p>
                        {dayjs(text)
                            .tz("Asia/Tashkent")
                            .format("DD.MM.YYYY HH:mm:ss")}
                    </p>
                )

        },

        {
            title: 'Статус',
            key: 'status',
            render: (_, record) => {

                const { faceType, attendance_key, attendance_time } = record;

                // IN
                if (faceType === 'in') {
                    if (attendance_key.includes('early')) {
                        return (
                            <Tag color="green">
                                Ерта келди ({minutesToHours(attendance_time)} )
                            </Tag>
                        )
                    }else
                    return (
                        <Tag color="red">
                            Кеч келди ({minutesToHours(attendance_time)} )
                        </Tag>
                    )
                }

                // OUT
                if (faceType === 'out') {
                    if (attendance_key.includes('early')) {
                        return (
                            <Tag color="red">
                                Ерта кетди ({minutesToHours(attendance_time)} )
                            </Tag>
                        )
                    }

                    return (
                        <Tag color="green">
                            Кеч кетди ({minutesToHours(attendance_time)} )
                        </Tag>
                    )
                }

                return '-'
            }
        },

    ];

    return (
        <Table
            className={'attendance'}
            size='small'
            columns={columns}
            dataSource={data}
            rowKey={(record) => record._id}
            pagination={{responsive: true}}
        />
    );
};

export default AttendanceTable;
